import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

import AchBalanceCheckDialog from './AchBalanceCheckDialog';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  // rollo user id (uuid)
  userId: string;
  paymentMethodId: string;
  // bank accounts without a Financial Connections link have no balance to check
  financialConnectionsAccount?: string | null;
}

// RLPR-20420 opens the on-demand bank balance check for a saved ACH bank account
const AchBalanceCheckButton = ({ userId, paymentMethodId, financialConnectionsAccount }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  if (!financialConnectionsAccount) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setOpen(true)}
        className={classes.button}>
        Check balance
      </Button>

      {open && (
        <AchBalanceCheckDialog
          open={open}
          onClose={() => setOpen(false)}
          userId={userId}
          paymentMethodId={paymentMethodId}
        />
      )}
    </>
  );
};

export default AchBalanceCheckButton;
